<template>
  <!-- <v-container fluid> -->
    <v-layout wrap>
      <!-- > Account field  <!-->
      <v-flex xs12 mt-2>
        <h1>Account Info</h1>
        <v-img style='border-radius: 50%; height:0px; width:75px; margin: 30px;'></v-img>
      </v-flex>

      <v-flex xs12 >
        <form>
          <v-layout column>
            <v-flex>
              <v-alert type="error" dismissible v-model="alert">
                {{ error }}
              </v-alert>
            </v-flex>
            <!-- > Tittle  <!-->
            <h3> Account Verification</h3>
            <p> Account Verified</p>

            <!-- > Email field  <!-->
            <h3> Email Address</h3>
            <p> {{ getEmail }}</p>

            <!-- > password field  <!-->
            <v-flex>
              <v-text-field
                name="password"
                label="Password"
                id="password"
                v-model="password"

                autocomplete="on"
                append-icon="edit"
                type="text"
                @click:append="wantToChange = !wantToChange, newPasswordSave = false"
                :rules="passwordRules"
                required
              ></v-text-field>
            </v-flex>
            <!-- > alert: if the password is correct <!-->
            <v-layout align-center justify-start row fill-height>
              <div v-if="!this.$store.state.check_Password">
                <v-alert :value="true" type="error">
                  The current password is incorrect.
                </v-alert>
              </div>
            </v-layout>

            <!-- > new password field  <!-->
            <div v-if="wantToChange">
              <v-flex>
                <v-text-field
                  name="new password"
                  label="New Password"
                  id="new password"
                  v-model="new_password"
                  :rules="passwordRules"
                  required
                ></v-text-field>
              </v-flex>

              <!-- > alert: if update the password successfully  <!-->
              <v-layout align-center justify-start row fill-height>
                <div v-if="this.$store.state.updatedPassword">
                  <v-alert :value="true" type="success">
                    New Password Saved
                  </v-alert>
                </div>
              </v-layout>

              <!-- > update button  <!-->
              <v-flex class="text-xs-center" mt-4>
                <v-btn color="primary" v-on:click="changePassword" :disabled="checkValid">Update</v-btn>
              </v-flex>

            </div>

          </v-layout>
        </form>
      </v-flex>
      <!-- > Account field  <!-->


      <v-flex xs12 mt-3>
        <h1>Profile Info</h1>
        <v-img style='border-radius: 50%; height:0px; width:75px; margin: 30px;'></v-img>
      </v-flex>

      <v-flex xs12 >
        <form @submit.prevent="saveProfile">
          <v-layout column>
            <v-flex>
              <v-alert type="error" dismissible v-model="alert">
                {{ error }}
              </v-alert>
            </v-flex>
            <v-flex>
              <v-text-field
                name="name"
                label="Name"
                id="name"
                type="text"
                prepend-icon="face"
                v-model="profile.name"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-textarea
                name="bio"
                label="Bio"
                id="bio"
                type="text"
                v-model="profile.bio"
                prepend-icon="edit"
              ></v-textarea>
            </v-flex>
            <v-flex>
              <!--  v-bind:readonly="true", can put in text-field below -->
              <v-text-field
                name="role"
                label="Role"
                id="role"
                type="text"
                hint="Administrator or User"
                prepend-icon="accessibility_new"
                v-model="profile.role"
              ></v-text-field>
            </v-flex>
            <!-- birthday field -->
            <v-flex>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="profile.birthday"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="profile.birthday"
                  label="Birthday"
                  id="birthday"
                  type="text"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="profile.birthday" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.menu.save(profile.birthday)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <!-- gender field -->
            <v-flex>
              <v-text-field
                name="gender"
                label="Gender"
                id="gender"
                type="text"
                prepend-icon="person_outline"
                v-model="profile.gender"
              ></v-text-field>
            </v-flex>
            <!-- hometown field -->
            <v-flex>
              <v-text-field
                name="hometown"
                label="Hometown"
                id="hometown"
                type="text"
                prepend-icon="home"
                v-model="profile.hometown"
              ></v-text-field>
            </v-flex>
            <!-- location field -->
            <v-flex>
              <v-text-field
                name="location"
                label="Location"
                id="location"
                type="text"
                v-model="profile.location"
                prepend-icon="location_on"
              ></v-text-field>
            </v-flex>

            <v-flex class="text-xs-center" mt-5 v-if="!savedProfile">
              <v-btn outline color="primary" type="submit">Save</v-btn>
              <v-btn outline color="primary" v-on:click="fbAuth">Pull From Facebook</v-btn>
            </v-flex>
            <v-alert
              icon="check_circle"
              :value="savedProfile"
              transition="scale-transition"
              type="success"
            >
              Profile Successfully Saved
            </v-alert>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  <!-- </v-container> -->
</template>

<script>

export default {
  data () {
    return {
      alert: false,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      savedProfile: false,
      password: '',
      new_password: '',
      showPassword: false,
      wantToChange: false,
      newPasswordSave: false,
      correctPassword: true,
      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Password should be at least 6 characters'
      ]
    }
  },
  computed: {
    comparePasswords () {
      return this.password === this.passwordConfirm ? true : 'Passwords don\'t match'
    },
    error () {
      return this.$store.state.error
    },
    loading () {
      return this.$store.state.loading
    },
    profile () {
      return this.$store.state.profile
    },
    getEmail () {
      return this.$store.state.user.email
    },
    checkValid () {
      return this.new_password.length < 6 || this.new_password === this.password
    }
  },
  methods: {
    saveProfile () {
      this.$store.dispatch('pushProfile')
      this.savedProfile = true
      if (this.savedProfile === true) {
        setTimeout(() => {
          this.savedProfile = false
        }, 3000)
      }
    },
    fbAuth: function (event) {
      this.$store.dispatch('fbLogin')
    },
    changePassword () {
      this.$store.dispatch('changePassword', {password: this.password, newPassword: this.new_password})
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.alert = true
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Profile.vue